import { defineDirective, FieldViewModel, IOmniaShell } from "../../../../omnia"
import { EditCtrl } from "../../../../requirements/edit/edit"
import { ReqZoneVM } from "../../../../requirements/edit/req-zone-vm"
import { IFieldsService, INutritionService } from "../../../../types"
import { TableDashboardContext } from "../../dashboardContext"


export class RequirementEditCtrl extends EditCtrl {

    static create(): ng.IDirective {
        return defineDirective(RequirementEditCtrl, "app/nutrition/dashboard/table/requirements/edit/edit.html", {
            context: "="
        });
    }

    public context: TableDashboardContext;

    private _selectionWatcher: Function;

    private _filteredCropping: FieldViewModel[];

    constructor(
        protected $scope: ng.IScope,
        protected svc: INutritionService,
        protected fieldSvc: IFieldsService,
        protected shell: IOmniaShell) {

        super($scope, svc, fieldSvc, shell);
    }

    $onInit() {

        this.setup().then(r => this.initCropping())

    }

    private initCropping() {

        if (this._selectionWatcher) {
            this._selectionWatcher();
        }

        var selection = this.context.cropping.filter(c => c.selected);

        if (selection.length === 1) {
            super.setupCurrentCropping(selection[0].croppingVm);
            if (selection[0].isZone) {
                let zone = this.zones.find(z => z.zoneNumber === selection[0].zoneNumber);
                this.selectedZone = zone || this.selectedZone;
            }
        }

        this._selectionWatcher = this.$scope.$watch("vm.context.selectionStr", () => this.applySelection());

    }

    private applySelection() {

        let selection = this.context.cropping.filter(c => c.selected);
        let s = selection.length === 1 ? selection[0] : null;
        if (!s) return;

        let cropping = this.fieldSvc.findCropping(s.croppingId);

        super.setupCurrentCropping(cropping);

        if (s.isZone) {
            let zone = this.zones.find(z => z.zoneNumber === s.zoneNumber);
            this.selectedZone = zone || this.selectedZone;
        }

    }

    public selectZone(zone: ReqZoneVM) {

        if (zone === this.selectedZone) return;

        super.selectZone(zone);

        if (!zone.zoneNumber) {
            this.context.cropping.forEach(c => c.selected = false);
            var cropping = this.context.cropping.find(c => c.croppingId === zone.croppingId && !c.isZone);
            if (cropping) {
                cropping.selected = true;
            }
            return;
        }

        this.context.cropping.forEach(c => c.selected = false);
        var zoneVm = this.context.cropping.find(c => c.croppingId === zone.croppingId && c.isZone && c.zoneNumber === zone.zoneNumber);
        if (zoneVm) {
            zoneVm.selected = true;
        }

    }

    protected updateOnSaved() {

        super.updateOnSaved();

        super.cancel()

    }

    protected cancelChanges() {
        let zone = this.selectedZone;
        super.cancelChanges();
        zone = this.zones.find(z => z.zoneNumber === zone.zoneNumber);
        this.selectZone(zone);
    }

    protected close() {
        this.context.edit = false;
    }

    protected dispose() {
        this.context.edit = false;
    }

}
